import { jsx as _jsx } from "react/jsx-runtime";
const Madden26Wordmark = ({ height, width, className }) => {
    return (_jsx("img", { src: "/img/games/sports/madden_nfl/madden-26/madden-26-full.png", height: height, width: width, className: className }));
};
export default Madden26Wordmark;
